<template>
    <img :src="imageURL" />
</template>
<script>
export default {
    name: "ImageChapter",
    props: {
        imageSrc: {
            type: String,
            default: "",
        },
    },
    computed: {
        imageURL() {
            return process.env.VUE_APP_API_BASE_URL + this.imageSrc;
        },
    },
};
</script>
